import { useParams, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import Line from "../components/textLine";
import Tag from "../components/tag";

function DetailPage() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState({});

  let { name } = useParams();

  useEffect(() => {
    fetch(`https://restcountries.com/v3.1/name/${name}`)
      .then((res) => res.json())
      .then((results) => {
        setIsLoaded(true);
        setData(results[0]);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, [name]);

  const country = {
    name: data["name"] ? data["name"]["common"] : "",
    population: data["population"] || "",
    region: data["region"] || "",
    flag: data["flags"] ? data["flags"]["svg"] : "",
    subregion: data["subregion"] || "",
    capital: data["capital"] ? data["capital"][0] : "",
    tld: data["tld"] ? data["tld"][0] : "",
    currencies: data["currencies"]
      ? Object.values(data["currencies"])[0]["name"]
      : "",
    languages: data["languages"]
      ? Object.values(data["languages"]).join(", ")
      : "",
    borders: data["borders"] || [],
  };

  return (
    <main className="detailpage">
      <div className="container">
        <section className="toolbar">
          <Link to="/" className="back-btn">
            <FontAwesomeIcon icon={faArrowLeft} className="fa-icon" />
            Back
          </Link>
        </section>
        <section className="detailpage-main grid">
          <div className="detailpage-img">
            <img src={country.flag} alt={`${country.common} Flag Image`} />
          </div>

          <div className="detailpage-content">
            <h1 className="detailpage-title">{country["name"]}</h1>
            <div className="detailpage-info flex">
              <div className="right-col">
                <Line title="Native Name" content={country["name"]} />
                <Line title="Population" content={country["population"]} />
                <Line title="Region" content={country["region"]} />
                <Line title="Sub Region" content={country["subregion"]} />
                <Line title="Capital" content={country["capital"]} />
              </div>
              <div className="left-col">
                <Line title="Top Level Domain" content={country["tld"]} />
                <Line title="Currencies" content={country["currencies"]} />
                <Line title="Languages" content={country["languages"]} />
              </div>
            </div>
            <div className="detailpage-borders">
              <Line
                title="Border Contries"
                content={country.borders.map((c) => (
                  <Tag key={c} name={c} />
                ))}
              />
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default DetailPage;
